module.exports = __webpack_public_path__ + "static/claims@2x.9895a6a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/connect/claims@2x.png
// module id = 885
// module chunks = 68530290604204